<template>
  <v-container>
    <v-row>
      Coming soon...
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Assets',
    components: {},
    computed: {},
  };
</script>
